/**
 * Tenant Sync Reports GETs (WSRADM-0014).
 *
 * Bare paths so `resolveBaseUrl` uses `apiBase()` (`/api`). Never
 * `/admin/platform/**`, never a tenant slug, never CSRF / cookies.
 * Filter "all" omits the key — never send `all` / `ALL`.
 */
import { request } from '@/api/client';
import type { PagedResponse } from '@/api/types';
import { parseDecisionsPage, parseJobsPage, parseLastRuns } from './parse';
import type {
  IngestionJobView,
  LastRunsResponse,
  ListDecisionsQuery,
  ListJobsQuery,
  SyncDecisionView,
} from './types';

function pagingQuery(
  extras: Record<string, string | number>,
  page: number,
  size: number,
): Record<string, string | number> {
  return { ...extras, page, size };
}

/** GET /admin/ingestion-jobs */
export async function listIngestionJobs(
  query: ListJobsQuery = {},
): Promise<PagedResponse<IngestionJobView>> {
  const page = query.page ?? 0;
  const size = query.size ?? 20;
  const extras: Record<string, string | number> = {};
  if (query.status !== undefined && query.status !== '') extras.status = query.status;
  if (query.type !== undefined && query.type !== '') extras.type = query.type;
  const body = await request<unknown>('GET', '/admin/ingestion-jobs', {
    query: pagingQuery(extras, page, size),
  });
  return parseJobsPage(body);
}

/** GET /admin/ingestion-jobs/{jobId}/decisions */
export async function listJobDecisions(
  jobId: number,
  query: ListDecisionsQuery = {},
): Promise<PagedResponse<SyncDecisionView>> {
  const page = query.page ?? 0;
  const size = query.size ?? 20;
  const extras: Record<string, string | number> = {};
  if (query.severity !== undefined && query.severity !== '') extras.severity = query.severity;
  const body = await request<unknown>('GET', `/admin/ingestion-jobs/${jobId}/decisions`, {
    query: pagingQuery(extras, page, size),
  });
  return parseDecisionsPage(body);
}

/** GET /admin/last-runs — not paged. */
export async function listLastRuns(): Promise<LastRunsResponse> {
  const body = await request<unknown>('GET', '/admin/last-runs');
  return parseLastRuns(body);
}
